import React from 'react';

export * from './hooks/use-siva-budget-attachments';

export const SivaReportingWrapperPage = React.lazy(() => import('./pages/SivaReportingWrapperPage'));
